import React, {useEffect, useState, useMemo} from 'react'
import cx from 'classnames';
import {Link} from 'react-router-dom';

import {getDictionaryData, getQueryString} from '../../../../modules/dictionary/dictionaryUtils';
import {DICTIONARY_INITIAL_SHOW_COUNT, DICTIONARY_TEXT} from '../../../../modules/dictionary/dictionaryConstants';

import style from './DictionaryList.scss';
import {scrollToTop} from '../../../../utils/scroll';

const DictionaryList = ({dictionary, categoryId, categoryName, isMobile = false}) => {
  const [showAllDirectory, setShowAllDirectory] = useState(true);

  useEffect(() => {
    setShowAllDirectory(false);
  }, [])

  const handleLoadMore = () => {
    setShowAllDirectory(true);
  };

  const onClickLink = () => {
    scrollToTop({behavior: 'auto'})
  }

  const dictionaryData = useMemo(() => getDictionaryData({dictionary, isAll: showAllDirectory}), [dictionary, showAllDirectory])
  const showLoadMoreButton = useMemo(() => {
    return dictionary?.length > DICTIONARY_INITIAL_SHOW_COUNT && !showAllDirectory
  }, [dictionary, showAllDirectory]);


  return (
    <div className={cx(style.root, {[style.mobile]: isMobile})}>
      <div className={style.logo}>
        <span>{DICTIONARY_TEXT.HEPSIBURADA}</span>
        <span>{DICTIONARY_TEXT.DICTIONARY}</span>
      </div>
      <span className={style.title}>
        {categoryName ? `${categoryName} ${DICTIONARY_TEXT.CATEGORY_MOST_KEYWORD}` : DICTIONARY_TEXT.THIS_CATEGORY_MOST_KEYWORD}
      </span>
      <div className={style.dictionaryList}>
        {
          dictionaryData?.map((item, index) => {
            const isDifferentCategory = categoryId && item?.categoryLandingPageId?.toString() !== categoryId;
            const NavLink = isDifferentCategory ? 'a' : Link;
            const url = `/${item.categoryLandingPageUrl}${getQueryString(item.keyword)}`;
            const linkProps = isDifferentCategory ? {href: url} : {to: url};

            return (
              <div key={index} className={cx(style.dictionaryListItem, {[style.noImage]: !item.seoImage})}>
                {
                  item.seoImage && (
                    <div className={style.image}>
                      <img src={item.seoImage}/>
                    </div>
                  )
                }
                <div className={style.textWrapper}>
                  <span className={style.keyword}>{item.keyword}</span>
                  <span className={style.content}>{item.seoContent}</span>
                </div>
                {
                  item.keyword &&
                    <NavLink
                      onClick={!isDifferentCategory && onClickLink}
                      className={style.detailButton}
                      {...linkProps}
                      title={item.keyword}>
                      <span>{DICTIONARY_TEXT.DETAIL}</span>
                    </NavLink>
                }
              </div>
            )
          })
        }
      </div>
      <div className={style.loadMoreWrapper}>
        {
          showLoadMoreButton && <span className={style.loadMoreButton} onClick={handleLoadMore}>{DICTIONARY_TEXT.SHOW_ALL}</span>
        }
      </div>
    </div>
  )
}

export default DictionaryList;
